import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "sentinel"]

  #observer

  connect() {
    this.#observer = new IntersectionObserver(([entry]) => {
      const pastSentinel = !entry.isIntersecting && entry.boundingClientRect.top < 0
      this.buttonTarget.classList.toggle("opacity-0", !pastSentinel)
      this.buttonTarget.classList.toggle("pointer-events-none", !pastSentinel)
    })
    this.#observer.observe(this.sentinelTarget)
  }

  disconnect() {
    this.#observer.disconnect()
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
